import { Box, FormControl, Select, MenuItem, Pagination } from "@mui/material";
import '../../pages/css/customPagination.css';
import  arrowRight  from "../../assets/arrow-right.svg";
import arrowLeft from '../../assets/arrow-left.svg';

export default function CustomPagination({ paginationModel, onPaginationModelChange, rowCount }) {
    const { page, pageSize } = paginationModel;

    const totalPages = Math.ceil(rowCount / pageSize);
    const from = page * pageSize + 1;
    const to = Math.min((page + 1) * pageSize, rowCount);

    const handlePrev = () => {
        if (page > 0) {
            onPaginationModelChange({ ...paginationModel, page: page - 1 });
        }
    };

    const handleNext = () => {
        if (page < totalPages - 1) {
            onPaginationModelChange({ ...paginationModel, page: page + 1 });
        }
    };

    const handlePageChange = (event, newPage) => {
        onPaginationModelChange({ ...paginationModel, page: newPage - 1 }); // MUI Pagination is 1-based
    };

    return (
        <Box display="flex" justifyContent="space-between" alignItems="center" padding={2}>
            <Box>
                {/* <span>row per page: </span> */}
                <FormControl className='select-entries select-entries-custom-pagination' variant="outlined" size="small">
                    <Select
                        value={paginationModel.pageSize}
                        onChange={(e) => onPaginationModelChange({ page: 0, pageSize: e.target.value })}
                    >
                        <MenuItem value={5}>5</MenuItem>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={25}>25</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            {/* <span>{`${from}-${to} out of ${rowCount}`}</span> */}

            <Pagination
                count={totalPages}
                page={page + 1} // MUI Pagination is 1-based
                onChange={handlePageChange}
                color="primary"
                shape="rounded"                
                hideNextButton
                hidePrevButton          
                className="custom-pagination-page-btn"     
            />
            <Box sx={{ marginLeft: "5px", display: "flex" }}>
                <button className='cstm-pagination-button' onClick={handlePrev} disabled={page === 0} >
                    <img src={arrowLeft} alt="" />
                </button>
                <button className='cstm-pagination-button' onClick={handleNext} disabled={page >= totalPages - 1}>
                <img src={arrowRight} alt="" />
                </button>
            </Box>
        </Box>
    );
};